import { c as _c } from "react/compiler-runtime";
import { StepBarItem } from './StepBarItem';
import { StepContent } from './StepContent';
export type Step = {
  id: number;
  title: string;
  content: React.ReactNode;
};
type ProgressBarProps = {
  steps: Step[];
  activeStepIdx: number;
};
export function ProgressBar(t0) {
  const $ = _c(12);
  const {
    steps,
    activeStepIdx
  } = t0;
  if (!steps || steps.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== activeStepIdx || $[1] !== steps) {
    let t2;
    if ($[3] !== activeStepIdx) {
      t2 = step => <StepBarItem key={step.id} stepId={step.id} isStepCompleted={activeStepIdx >= step.id} title={step.title} />;
      $[3] = activeStepIdx;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = steps.map(t2);
    $[0] = activeStepIdx;
    $[1] = steps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:gap-8">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = steps[activeStepIdx - 1];
  let t4;
  if ($[7] !== t3.content) {
    t4 = <StepContent>{t3.content}</StepContent>;
    $[7] = t3.content;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <section className="w-full">{t2}{t4}</section>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}